import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M100 99.8c9.6-.1 19-3.1 27-8.6 7.9-5.5 14.1-13.1 17.7-22.1 3.6-8.9 4.5-18.8 2.5-28.2-2-9.4-6.7-18.1-13.5-24.9-6.9-6.8-15.6-11.4-25-13.2C99.2 1 89.4 2 80.5 5.7c-8.9 3.7-16.5 10-21.8 18-5.3 8-8.2 17.4-8.2 27.1.1 13.1 5.4 25.5 14.7 34.7 9.2 9.3 21.7 14.4 34.8 14.3zm0-14c-6.9-.1-13.6-2.2-19.3-6.1-5.7-3.9-10.1-9.4-12.6-15.8-2.6-6.4-3.2-13.4-1.8-20.1 1.4-6.8 4.8-13 9.7-17.8 4.9-4.8 11.1-8.1 17.9-9.4 6.8-1.3 13.8-.6 20.1 2.1 6.4 2.7 11.8 7.1 15.6 12.9 3.8 5.7 5.9 12.5 5.9 19.4 0 4.6-1 9.2-2.8 13.4-1.8 4.3-4.4 8.1-7.7 11.4-3.3 3.2-7.2 5.8-11.5 7.5-4.3 1.7-8.9 2.5-13.5 2.5z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M86 58h28c-.1 3.7-1.6 7.1-4.2 9.7-2.6 2.6-6.1 4-9.8 4-3.7 0-7.2-1.4-9.8-4-2.6-2.6-4.1-6.1-4.2-9.7z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M54.3 114.2h91.5c25.3 0 45.7 18.8 45.7 41.9S171 198 145.7 198H54.3C29 198 8.5 179.2 8.5 156.1s20.5-41.9 45.8-41.9zm-.7 14c-3.9-.4-7.9 0-11.6 1.2-3.8 1.2-7.2 3.2-10.1 5.8-2.9 2.6-5.3 5.9-6.9 9.5-1.6 3.6-2.4 7.5-2.4 11.4s.8 7.8 2.4 11.4c1.6 3.6 4 6.8 6.9 9.5 2.9 2.6 6.4 4.6 10.1 5.8 3.8 1.2 7.7 1.6 11.6 1.2h92.9c3.9.4 7.9 0 11.6-1.2 3.8-1.2 7.2-3.2 10.1-5.8 2.9-2.6 5.3-5.9 6.9-9.5 1.6-3.6 2.4-7.5 2.4-11.4s-.8-7.8-2.4-11.4c-1.6-3.6-4-6.8-6.9-9.5-2.9-2.6-6.4-4.6-10.1-5.8-3.8-1.2-7.7-1.6-11.6-1.2H53.6z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
  ], 4))
}